import { render } from "./Quote.vue?vue&type=template&id=18dcdb35"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Misc/Quote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18dcdb35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18dcdb35', __exports__)) {
    api.reload('18dcdb35', __exports__)
  }
  
  module.hot.accept("./Quote.vue?vue&type=template&id=18dcdb35", () => {
    api.rerender('18dcdb35', render)
  })

}


export default __exports__